export default __webpack_public_path__ + "static/media/instagram-icon.51721605.svg";